import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { PdfService } from 'src/app/modules/shared/services/pdf.service';

@Component({
  selector: 'app-voucher-document-viewer',
  templateUrl: './voucher-document-viewer.component.html',
  styleUrls: ['./voucher-document-viewer.component.scss'],
})
export class VoucherDocumentViewerComponent implements OnInit {

  code: any = "";
  pdfURL!: SafeResourceUrl;

  showPDF: boolean = false;
  showSpinner: boolean = false;
  constructor(
    private _activatedRoute: ActivatedRoute,
    private _pdfService: PdfService,
    private _sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.showSpinner = true;
    this.code = this._activatedRoute.snapshot.paramMap.get("code");
    this._pdfService.getVoucherPdfFromLookupCode(this.code)
      .subscribe((response: any) => {
        const file = new Blob([response], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(file);
        if (/Mobi|Android/i.test(navigator.userAgent)) {
          window.open(blobUrl, '_blank');
        } else {
          this.pdfURL = this._sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
          this.showPDF = true;
        }
        this.showSpinner = false;
      }, err => {
        console.error('Error fetching PDF', err);
        this.showSpinner = false;
      });
  }

}
